import { render, staticRenderFns } from "./inputText.pug?vue&type=template&id=0205a4ed&lang=pug&"
import script from "./inputText.js?vue&type=script&lang=js&"
export * from "./inputText.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0205a4ed')) {
      api.createRecord('0205a4ed', component.options)
    } else {
      api.reload('0205a4ed', component.options)
    }
    module.hot.accept("./inputText.pug?vue&type=template&id=0205a4ed&lang=pug&", function () {
      api.rerender('0205a4ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/text/index.vue"
export default component.exports